import { Info, X } from 'lucide-react';
import type { IntentClassification } from '@/types/floorplanClassification';

interface FloorplanUncertainHintProps {
  classification: IntentClassification;
  onDismiss: () => void;
}

export function FloorplanUncertainHint({ onDismiss }: FloorplanUncertainHintProps) {
  return (
    <div className="border-l-4 border-[#fe7f2e] bg-stone-50 p-4 rounded-r-md my-2">
      <div className="flex items-start gap-3">
        <Info className="h-5 w-5 text-[#fe7f2e] flex-shrink-0 mt-0.5" aria-hidden />
        <div className="flex-1 space-y-2 text-sm">
          <p className="font-medium text-stone-900">Anfrage nicht eindeutig</p>
          <p className="text-stone-700">
            Wir konnten nicht klar erkennen, was geändert werden soll. Bitte präzisieren Sie:
          </p>
          <ul className="list-disc list-inside text-stone-700 space-y-1 ml-1">
            <li>Markieren Sie einen Bereich im Bild, oder</li>
            <li>
              Beschreiben Sie konkret, was Sie ändern möchten
              (z.B. „Wände dunkler machen" oder „Möbel moderner")
            </li>
          </ul>
          <p className="text-xs text-stone-500 italic">
            Es wurde kein Credit verbraucht.
          </p>
        </div>
        <button
          type="button"
          onClick={onDismiss}
          aria-label="Schließen"
          className="text-stone-400 hover:text-stone-600"
        >
          <X className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
}
